export const DEFAULT_MODAL_WIDTH = 520;
export const WRAP_CLASSNAME = 'modal-wrapper';
export const MODAL_NO_PADDINGS_CLASS = 'modal-no-paddings';
export const MODAL_PADDING_8_STEPS = 'modal-padding-8-steps';
export const MODAL_DISABLE_MIN_HEIGHT_CLASS = 'modal-disable-min-height';
export const MODAL_ULTRA_HIGH_Z_INDEX = 'modal-ultra-high-z-index';
